import {AfterViewInit, Component, Input, QueryList, ViewChildren} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlName,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {AbstractComponent} from '../abstract.component';
import {CustomTimeValue} from "@model";

@Component({
  selector: 'app-duration-input',
  templateUrl: './duration-input.component.html',
  styleUrls: ['./duration-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DurationInputComponent,
    multi: true
  }]
})
export class DurationInputComponent extends AbstractComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label?: string;
  @Input() translatedLabel?: string;
  @Input() formControlName?: string;

  @ViewChildren(FormControlName) formControlDirectives?: QueryList<FormControlName>;

  form = new FormGroup({
    hours: new FormControl(),
    minutes: new FormControl(),
    seconds: new FormControl(),
  });

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  ngAfterViewInit(): void {
    this.formControlDirectives?.forEach((formControlName: FormControlName) => {
      formControlName?.valueAccessor?.registerOnTouched(this.onTouched);
    });
  }

  // get hold of FormControl instance no matter formControl or formControlName is given.
  // If formControlName is given, then this.controlContainer.control is the parent FormGroup (or FormArray) instance.
  get control(): FormControl {
    return <FormControl<any>>this.controlContainer!.control!.get(this.formControlName!);
  }

  onChange: Function = () => {
  };
  onTouched: Function = () => {
  };

  writeValue(value: CustomTimeValue | undefined): void {
    this.form.controls.hours.setValue(value?.hours);
    this.form.controls.minutes.setValue(value?.minutes);
    this.form.controls.seconds.setValue(value?.seconds);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: Function): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    if (disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  ngOnInit() {
    this.subscriptions.push(this.form.controls.hours.valueChanges.subscribe((value: number) => {
      this.changeValue();
    }));

    this.subscriptions.push(this.form.controls.minutes.valueChanges.subscribe((value: number) => {
      this.changeValue();
    }));

    this.subscriptions.push(this.form.controls.seconds.valueChanges.subscribe((value: number) => {
      this.changeValue();
    }));
  }

  private changeValue() {
    let customTimeValue: CustomTimeValue = new CustomTimeValue();
    customTimeValue.hours = this.form.controls.hours.value;
    customTimeValue.minutes = this.form.controls.minutes.value;
    customTimeValue.seconds = this.form.controls.seconds.value;
    if (!!!customTimeValue.hours && !!!customTimeValue.minutes && !!!customTimeValue.seconds) {
      this.onChange(undefined);
    } else if (customTimeValue.hours == 0 && customTimeValue.minutes == 0 && customTimeValue.seconds == 0) {
      this.onChange(undefined);
    } else if ((typeof customTimeValue.minutes === "number") && (customTimeValue.minutes < 0 || customTimeValue.minutes > 60)) {
      this.onChange(undefined);
    } else if ((typeof customTimeValue.seconds === "number") && (customTimeValue.seconds < 0 || customTimeValue.seconds > 60)) {
      this.onChange(undefined);
    } else {
      this.onChange(customTimeValue);
    }
  }
}
